import styled from "styled-components";

export const Container = styled.div`
  background-color: #f9ae1761;
  color: #000;
  padding: 40px 40px;
  border-radius: 20px;
`;
